import { useEffect, useState } from "react";

export default function RenameModal({ item, onClose, onSave }) {
  const [value, setValue] = useState(item.file_name ?? "");
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState("");

  const trimmed = value.trim();
  const isValid = trimmed.length > 0;

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "Enter" && isValid) handleSave();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  });

  const handleSave = async () => {
    if (!isValid) return;

    try {
      setError("");
      await onSave(trimmed);  
      onClose();               
    } catch (err) {
      const msg =
        err?.message ||
        "Something went wrong while renaming. Please try again.";
      setError(msg);          
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
      onClick={onClose}
      aria-modal="true"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-sm rounded-2xl bg-white shadow-xl border border-gray-100 p-5 sm:p-6"
      >
        <div className="flex items-start justify-between mb-3">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Rename consultation
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              This updates the name for all notes in this consultation.
            </p>
          </div>

          <button
            onClick={onClose}
            aria-label="Close rename dialog"
            className="p-1.5 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            ✕
          </button>
        </div>

        <input
          autoFocus
          className={`w-full rounded-lg border px-3 py-2 text-sm outline-none shadow-sm ${
            !isValid && touched
              ? "border-red-400 focus:border-red-500 focus:ring-red-500"
              : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          }`}
          value={value}
          onChange={(e) => {
            setTouched(true);
            setValue(e.target.value);
            setError("");
          }}
          placeholder="Enter consultation name"
        />

        {!isValid && touched && (
          <p className="mt-1 text-xs text-red-500">Name cannot be empty.</p>
        )}

        {error && (
          <p className="mt-2 text-xs text-red-600 bg-red-50 border border-red-200 rounded p-2">
            {error}
          </p>
        )}

        <div className="mt-5 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            disabled={!isValid}
            onClick={handleSave}
            className={`px-3 py-1.5 rounded-lg text-white font-medium ${
              isValid
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-blue-300 cursor-not-allowed"
            }`}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
